import React, { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { Card, CardBody, CardHeader, Col, Container, Row, Table, Spinner } from 'reactstrap';
import BreadCrumb from '../components/Common/BreadCrumb';

import { createDeepClone } from "../utils/index";

import CardLoader from "../components/CardLoader";
import PaginationComponent from "../components/PaginationComponent";
import MySearchOption from "../components/MySearchOption";
import MyDateRenderer from "../components/MyDateRenderer";

import { useDispatch, useSelector } from "react-redux";
import * as customerActions from "../actions/CustomerActions";

const CustomerSearchScreen  = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    const user = useSelector((state) => state.login.user);
    const loading = useSelector((state) => state.customer.loading);
    const list = useSelector((state) => state.customer.list);
    const filter = useSelector((state) => state.customer.filter);

    const doSearch = () => {
        var copy_filter = createDeepClone(filter);
        
        if(copy_filter.pageIndex == 1) {
            dispatch(customerActions.loadCustomerSearch(filter, navigate));
        }
        else {
            copy_filter.pageIndex = 1;
            dispatch(customerActions.setCustomerFilter(copy_filter));
        }
    }

    React.useEffect(() => {
		dispatch(customerActions.loadCustomerSearch(filter, navigate));
    }, [filter.pageIndex]);

    const onFilterChange = (name, value) => {
        var copy_filter = createDeepClone(filter);
        copy_filter[name] = value;
        dispatch(customerActions.setCustomerFilter(copy_filter));
    }
    
    const onPageChange = (page) => {
        var copy_filter = createDeepClone(filter);
        copy_filter.pageIndex = page;
        dispatch(customerActions.setCustomerFilter(copy_filter));
    }
    
    return(
        <Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Customer Search" />
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody className="border border-dashed border-end-0 border-start-0">
                                    <Row className="gy-3">
                                        <Col xxl={(user && user.canAddCustomer) ? 6 : 8} md={12}>
                                            <MySearchOption
                                                placeholder={"Search for ticket customers..."}
                                                value={filter.search}
                                                searchList={list.searchList || []}
                                                fieldName="search"
                                                onChange={onFilterChange}
                                            />
                                        </Col>
                                        <Col xxl={2} md={12}>
                                            <select className="form-select"
                                                value={filter.active}
                                                onChange={e => onFilterChange("active", e.target.value)}
                                            >
                                                <option value={""}>All</option>
                                                <option value={true}>Active</option>
                                                <option value={false}>InActive</option>
                                            </select>
                                        </Col>
                                        <Col xxl={2} md={12}>
                                            <button type="button" className="btn btn-primary btn-label w-100" 
                                                disabled={loading}
                                                onClick= {() => doSearch()}
                                            >
                                                <i className="ri-search-eye-line label-icon align-middle"></i> Search
                                            </button>
                                        </Col>
                                        {user && user.canAddCustomer &&
                                        <Col xxl={2} md={12}>
                                            <Link to={`/customer-add`} className="btn btn-primary btn-label w-100">
                                                <i className="ri-add-line label-icon align-middle"></i> Add Customer
                                            </Link>
                                        </Col>
                                        }
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardLoader loading={loading} />
                                <CardBody>
                                    <div className="table-responsive table-card">
                                        <Table className="table-hover align-middle mb-0">
                                            <thead className="table-primary">
                                                <tr>
                                                    <th style={{width:10}}>&nbsp;</th>
                                                    <th>Organization Name</th>
                                                    <th>Customer Code</th>
                                                    <th>CRM Country</th>
                                                    <th>Email</th>
                                                    <th>Active</th>
                                                    <th>Action Date</th>
                                                    <th>Action By</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {list.dataList.map(function(item, index){
                                                    return(
                                                        <tr key={index}>
                                                            <td>
                                                                <div className="flex-shrink-0">
                                                                    <ul className="list-inline tasks-list-menu mb-0">
                                                                        <li className="list-inline-item">
                                                                            <Link to={`/customer-edit/${item.id}`}>
                                                                                <i className="ri-pencil-fill fs-20 align-bottom text-primary"></i>
                                                                            </Link>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </td>
                                                            <td>{item.organizationName}</td>
                                                            <td>{item.code}</td>
                                                            <td>{item.crmCountry}</td>
                                                            <td>{item.email}</td>
                                                            <td>{item.active ? "Yes" : "No"}</td>
                                                            <td><MyDateRenderer value={item.lastActionDate} /></td>
                                                            <td>{item.updatedBy}</td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </Table>
                                    </div>
                                    <Row>
                                        <Col lg={12}>
                                            <PaginationComponent
                                                total={list.totalCount}
                                                currentPage={filter.pageIndex}
                                                onPageChange={page => onPageChange(page)}
                                            />
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </Fragment>
    );
}

export default CustomerSearchScreen;